// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"87":"c577b42c","225":"ee68466e","413":"030d77e8","639":"b2c36977","745":"96d64352","837":"35f35f7e","838":"d938d2e6"}[chunkId] + ".js";
};